/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AbstractControl, ValidationErrors } from '@angular/forms';

const validateRegon = (regon: string): boolean => {
  if (regon.length !== 9 && regon.length !== 14) {
    return false;
  }

  const weights9 = [8, 9, 2, 3, 4, 5, 6, 7];
  const weights14 = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];
  const weights = regon.length === 9 ? weights9 : weights14;
  let sum = 0;

  for (let i = 0; i < weights.length; i++) {
    sum += parseInt(regon.charAt(i), 10) * weights[i];
  }

  const checksum = sum % 11;
  const lastDigit = parseInt(regon.charAt(regon.length - 1), 10);

  if (checksum === lastDigit) {
    return true;
  } else {
    return checksum === 10 && lastDigit === 0 && regon.length === 9;
  }
};

const RegonValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const value = formControl && (formControl.value as string);

  if (!value) {
    return {};
  }

  const regon = !validateRegon(value);

  if (!regon) {
    return {};
  }

  return { regon };
};

export default RegonValidator;
